import { Div } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { PackageFromCustomerStepData } from "../Models/PackageFromCustomerStepData";


export class InpostReturnInfo extends Div
{
    constructor(data: PackageFromCustomerStepData)
    {
        super();
        this.MarginTopBottom(8);

        const table = new Table().Class("payment-info-table")
            .AddRow("Paczkomat", "Inpost WAW02H")
            .AddRow("Adres", "Człuchowska 2A\n01-100 Warszawa")
            .AddRow("Odbiorca", "specTeam")
            .AddRow("Telefon", "507-293-714")
            .AddRow("Email", "specteam@specteam.pl");

        if (data.ManaInPackage.value > 0)
            table.AddRow("Dopłata", data.ManaInPackage.value + " zł, gotówka w przesyłce");

        this.Append(
            table
        );
    }
}
